import { apiUrl } from '../utils/constants';
import { DELETE, GET, POST, PUT } from './api.service.wrapper';



export const GetProduct = async (keyword = '', page = '', perPage = '', is_paginate = 1, status = null, category=null) => {
    let params = {};

    if (page) {
        params['page'] = page;
    }

    if (perPage) {
        params['per_page'] = perPage;
    }


    if (keyword) {
        params['title'] = keyword;
    }

    if (status) {
        params['status'] = status;
    }

    if (category) {
        params['category_id'] = category;
    }

    params['paginate'] = is_paginate;

    const response = await GET(apiUrl.product, params);
    return response;
}

export const GetProductById = async (id) => {
    let params = {};
    let response = '';
    response = await GET(apiUrl.product + '/' + id,params);
    return response;
}

export const CreateProduct = async (data) => {
    const response = await POST(apiUrl.product, data);
    return response;
}

export const UpdateProduct = async (id, data) => {
    const response = await PUT(apiUrl.product, id, data);
    return response;
}

export const DeleteProduct = async (id) => {
    const response = await DELETE(apiUrl.product, id);
    return response;
}
